import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconAdjustments } from "@tabler/icons-react";
import { KeyConstant, LangConstant } from "const";
import { BranchUtils, StorageUtils } from "utils";
import { useUpdateBranch } from "hooks";
import { PaperHeader } from "components";

const ChangeMode = () => {
  const { t: getLabel } = useTranslation();
  const { updateBranchInfo } = useUpdateBranch();

  const branchModeArr = LangConstant.BRANCH_MODE;
  const loginModeArr = LangConstant.LOGIN_MODE;

  const currentBranchMode = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_MODE);
  const currentLoginMode = StorageUtils.getStoreData(KeyConstant.KEY_LOGIN_MODE);

  const [branchMode, setBranchMode] = useState(currentBranchMode);
  const [loginMode, setLoginMode] = useState(currentLoginMode);

  const handleSubmit = event => {
    event.preventDefault();
    const currentBranchDetails = BranchUtils.getCurrentBranch();
    const payload = { ...currentBranchDetails, loginMode, branchMode, isUpdateBranchConfigs: true };
    updateBranchInfo(payload);
  };

  const handleChangeBranchMode = event => {
    setBranchMode(event.target.value);
  };

  const handleChangeLoginMode = event => {
    setLoginMode(event.target.value);
  };

  return (
    <div>
      <div>
        <PaperHeader icon={<IconAdjustments size={24} className="text-primary" />} title={getLabel(LangConstant.TXT_MODE)} />
        <form onSubmit={handleSubmit}>
          <h4 className="mt-3 mb-2">{getLabel(LangConstant.TXT_BRANCH_MODE)}</h4>
          <div className="mb-4">
            {branchModeArr.map(mode => (
              <label className="form-check" key={mode.code}>
                <input
                  type="radio"
                  className="form-check-input"
                  name="branchMode"
                  value={mode.code}
                  checked={mode.code === branchMode}
                  onChange={handleChangeBranchMode}
                />
                <span className="form-check-label">{getLabel(mode.label)}</span>
              </label>
            ))}
          </div>

          <h4 className="mt-3 mb-2">{getLabel(LangConstant.TXT_LOGIN_MODE)}</h4>
          <div className="mb-3">
            {loginModeArr.map(mode => (
              <label className="form-check" key={mode.code}>
                <input
                  type="radio"
                  className="form-check-input"
                  name="loginMode"
                  value={mode.code}
                  checked={mode.code === loginMode}
                  onChange={handleChangeLoginMode}
                />
                <span className="form-check-label">{getLabel(mode.label)}</span>
              </label>
            ))}
          </div>

          <div className="text-center">
            <button
              className="btn btn-primary"
              type="submit"
              disabled={branchMode === currentBranchMode && loginMode === currentLoginMode}
              style={{ minWidth: "345px", minHeight: "46px" }}
            >
              {getLabel(LangConstant.L_SAVE_BUTTON)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeMode;
